module.exports = __webpack_public_path__ + "static/team_industry-12f7a315eb1b0810e473884f7e4a3889.svg";